import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import DateCell from '../../../elements/Table/Cells/DateCell'
import CustomTable from '../../../elements/Table/CustomTable'

function List(props) {
  const { data: list, fetching, fetch } = useFetch({
    url: '/emails?select=_id,_key,to,cc,bcc,from,subject,owner,detail&type=campaign',
  })
  const columns = [
    {
      Header: 'Code',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/email/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Subject',
      accessor: 'subject',
    },
    {
      Header: 'From',
      accessor: 'from',
    },
    {
      Header: 'To',
      accessor: 'to',
    },
    {
      Header: 'CC',
      accessor: 'cc',
    },
    {
      Header: 'date',
      accessor: 'detail.mail.timestamp',
      Cell: DateCell,
    },
    {
      Header: 'BCC',
      accessor: 'bcc',
    },
    {
      Header: 'Sender',
      accessor: 'owner.fn',
    },
    {
      Header: 'Status',
      accessor: 'detail.notificationType',
      width: 100,
    },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
      defaultSorted={[
        {
          id: 'detail.mail.timestamp',
          desc: true,
        },
      ]}
    />
  )
}

export default withRouter(List)
